import React, { useState, useEffect } from "react";
import styles from "./page_styles.module.scss";
import globalStyles from "../global.module.scss";
import Navbar from "../components/Navbar/Navbar";
import { marked } from "marked";
import client from "../services/contentful.js";
import Footer from "../components/Footer/Footer";

const Integritetspolicy = () => {
  const [isLoading, setisLoading] = useState(true);
  const [integritetsBanner, setIntegritetsBanner] = useState("");
  const [content, setContent] = useState([]);

  useEffect(() => {
    const getBannerContent = () => {
      client.getEntry("2n0cKLkELgQdKgBBN5gCyi").then((entry) => {
        setContent(entry.fields);
        setIntegritetsBanner(entry.fields.banner.fields.file.url);
      });

      setisLoading(false);
    };

    getBannerContent();
  }, []);

  return (
    <>
      {isLoading ? (
        <></>
      ) : (
        <div className={styles.container}>
          <Navbar />
          <div
            className={styles.banner}
            style={{ backgroundImage: `URL(https:${integritetsBanner})` }}
          >
            <h1 className={globalStyles.max_width}>{content.title}</h1>
          </div>
          <div
            className={`${styles.content} ${globalStyles.max_width}`}
            dangerouslySetInnerHTML={{
              __html: marked(
                content.beskrivning !== undefined || null
                  ? content.beskrivning
                  : ""
              ),
            }}
          />
          <div>
            <Footer />
          </div>
        </div>
      )}
    </>
  );
};

export default Integritetspolicy;
